const small = [
  [{ name: 'side-nav', start: 1, span: 6 }],
  [{ name: 'heading', start: 1, span: 6 }],
  [{ name: 'body', start: 1, span: 6 }]
]

const large = [
  [
    { name: 'side-nav', start: 1, span: 3 },
    { name: 'body', start: 5, span: 8 },
    { name: 'heading', start: 5, span: 8 }
  ],
  [
    { name: 'side-nav', start: 1, span: 3 },
    { name: 'body', start: 5, span: 8 }
  ]
]

export const areas = {
  xs: small,
  sm: small,
  md: small,
  lg: large,
  xl: large,
  '2xl': large
}
